// import { useReactiveVar } from "@apollo/client";
import { __ } from "@wordpress/i18n";
// import { form, result } from "../../../stores";
import { useResult } from "../../../shared/formContext/hooks/useResult";
// Result Types
import Error from "../../../shared/Error/Error";
import TaxaEsforco from "./Result/TaxaEsforco";

// Components
import Loading from "../../../components/Loading/Loading";
import Empty from "../../../shared/Empty/Empty";
/**
 * UI message constants with proper Portuguese localization
 */
const UI_MESSAGES = {
  LOADING: __("A carregar...", "df-simulators"),
  ERROR_STATUS: __(
    "Ocorreu um erro ao carregar os resultados.",
    "df-simulators",
  ),
  NO_RESULTS: __("Não há resultados disponíveis no momento.", "df-simulators"),
  INITIAL_STATE: __(
    "Preencha o formulário e clique em Simular para ver os resultados.",
    "df-simulators",
  ),
};

/**
 * Results component orchestrates the display of appropriate UI states for effort rate calculator
 *
 * @returns {JSX.Element} Rendered results component
 */
const Results = () => {
  const { resultData } = useResult();
  const { response, loading, statusCode } = resultData;

  const renderResult = () => {
          // Render loading component if loading and no response yet
          if (loading) {
              return <Loading message={UI_MESSAGES.LOADING}/>;
          }
  
          // Render empty state if there is no response and no previous result - only desktop
          if (!response) {
              return (<div className="hidden lg:flex flex-col gap-12">
                  <Empty message={UI_MESSAGES.NO_RESULTS}/>
              </div>);
          }
  
          // Render error component if there is a status code other than 200
          if (statusCode && statusCode !== 200) {
              console.warn(UI_MESSAGES.ERROR_STATUS);
              return <Error/>;
          }
  
          return <TaxaEsforco/>;
      };
  
      return (
          <div className="tool-block__component__results__result">
              {renderResult()}
          </div>
      );
  
};

export default Results;
